import { render, staticRenderFns } from "./SubscriptionSubmissions.vue?vue&type=template&id=597c6d60&"
import script from "./SubscriptionSubmissions.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597c6d60')) {
      api.createRecord('597c6d60', component.options)
    } else {
      api.reload('597c6d60', component.options)
    }
    module.hot.accept("./SubscriptionSubmissions.vue?vue&type=template&id=597c6d60&", function () {
      api.rerender('597c6d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/SubscriptionSubmissions/SubscriptionSubmissions.vue"
export default component.exports